/* global ym */

export function reachMetrikaGoal(goal) {
    // todo: use here any sender to metrics
}
